import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchesState } from 'xstate';

export function usePageTitle(pageTitle, enabled = true) {
  const brandingName = useSelector(
    (state) => state.branding?.name || 'BallotTrax',
  );
  const translationsComplete = useSelector((state) =>
    state.machine?.value
      ? matchesState('translations.complete', state.machine.value)
      : false,
  );
  const fullTitle = `${pageTitle} — ${brandingName}`;

  useEffect(() => {
    if (!enabled || !translationsComplete) return;
    document.title = fullTitle;
    return () => {
      document.title = brandingName;
    };
  }, [enabled, translationsComplete, fullTitle, brandingName]);
}
